module.exports = __webpack_public_path__ + "static/media/tpdb.be6f4e8d.svg";